(function(algolia) {
  'use strict';
  algolia.translations = {
    searchTitle: 'Risultati della ricerca',
    search: 'Ricerca corrente',
    allProducts: 'Mostra tutti i prodotti',
    matching: 'Corrispondenza',
    sortBy: 'Ordina per',
    relevance: 'Rilevanza',
    outOf: 'out of',
    resultsFound: 'Risultati trovati',
    oneResultFound: '1 risultato trovato',
    noResultFound: 'Nessun risultato',
    addToCart: 'Aggiungi al carrello',
    searchForProduct: 'Cerca prodotti',
    selectedFilter: 'Filtri',
    clearAll: 'Resetta',
    outOfStock: 'Out of stoc',
    products: 'Prodotti',
    collections: 'Collezioni',
    articles: 'Articoli',
    pages: 'Pagina',
    try: 'Prova',
    clearFilters: 'Cancella filtri',
    or: 'o',
    changeInput: 'cambiando input',
    showLess: 'Mostra meno',
    showMore:'Mostra di più'
  };

  algolia.translation_helpers = {
    no_result_for: function(text) {
      return 'Nessun risultato per " ' + text + ' ".';
    },
    in: function(processingTimeMS) {
      return 'in ' + processingTimeMS / 1000 + 's';
    },

    outOf: function(page, hitsPerPage, nbHits) {
      return (
        page * hitsPerPage +
        1 +
        '-' +
        Math.min((page + 1) * hitsPerPage, nbHits) +
        ' out of'
      );
    },

    by: function(text) {
      if (!text) return '';
      return ' by ' + text;
    },

    render_title: function(text, query){
      if (text === 'Products' && query) {
        return text + ' for ' + query;
      }
      return text;
    }
  };
})(window.algoliaShopify);
